<template>
  <q-separator :color="color" :spaced="spaced" :vertical="vertical"/>
</template>

<script>
export default {
  name: 'RSeparator',
  props: {
    color: String,
    spaced: Boolean,
    vertical: Boolean,
  },
};
</script>
